import 'alpinejs';
/**
 * Finds a tags inside of a module that contain images and auto adds
 * builds a MicroModal instance containing an image built from the href,
 * attaches a listener to the wrapping a so that when the user clicks a
 * link it loads in a modal
 */
export default class RegistrationHelper {
    constructor(el) {
        this.el = el;
        this.vars();
    }
    vars() {
        window.RegistrationHelper = this.RegistrationHelper;
    }
    RegistrationHelper = ($el) => {
        return {
            el: $el,
            pricePerPerson: null,
            prettyPricePerPerson: null,
            tickets: 1,
            limit: null,
            total: null,
            prettyTotal: null,
            showLimitWarn: false,
            init: function() {
                this.getPricePerPerson()
                this.countTickets()
                this.updateTotal()
                this.handleTableUpdate()
                this.getClassLimit()
                this.countExistingTickets()
            },
            handleTableUpdate() {
                const form = document.querySelector('[data-freeform]');
                form.addEventListener("freeform-field-table-after-row-added", (event) => {
                    this.countTickets()
                    this.updateTotal()
                    this.checkLimit()
                });
                form.addEventListener("freeform-field-table-after-remove-row", (event) => {
                    this.countTickets()
                    this.updateTotal()
                    this.checkLimit()
                });
            },
            getClassLimit() {
              this.limit = this.el.dataset.limit;
            },
            getPricePerPerson() {
                this.pricePerPerson = this.el.dataset.pricePerPerson;
                this.prettyPricePerPerson = this.formatCurrency(this.pricePerPerson);
            },
            checkLimit() {
              this.showLimitWarn = this.tickets > this.limit;
            },
            updateTotal() {
                this.total = this.tickets * this.pricePerPerson
                this.prettyTotal = this.formatCurrency(this.total)
            },

            countExistingTickets() {
              const existing = document.querySelector('[data-existing-ticket-count]')
              if(typeof(existing) !== 'undefined' && existing) {
                  this.tickets = parseInt(existing.dataset.existingTicketCount);
              }
            },
            countTickets() {
                const table = document.querySelector('.attendees-roster');
                if(typeof table === 'undefined' || !table) {
                    return true;
                }
                const body = table.querySelector('tbody');
                const tickets = body.querySelectorAll('tr');
                this.tickets = tickets.length;
            },
            formatCurrency(number) {
                if(number === null) {
                    return true;
                }
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });
                return formatter.format(number);
            }
        }
    }
}
